import { PasswordResetResponseWrapper } from 'com.cogvio.pricemonitor.api';
import { apiClientMutator } from '~/infrastructure/config/mutator';

export function getPasswordReset(token: string, userId: string) {
	return apiClientMutator<PasswordResetResponseWrapper>({
		url: `/authentication/password/reset/${token}?user=${userId}`,
		method: 'get',
	});
}

export function setNewPassword(token: string, userId: string, password: string) {
	return apiClientMutator<void>({
		url: `/authentication/password/reset/${token}?user=${userId}`,
		method: 'put',
		data: { password: password },
	});
}
